export default __webpack_public_path__ + "static/media/step1.dbd26f0b.jpg";